// components/tracking/HeaderActions.jsx
import React from 'react';
import { FaEye, FaShare } from 'react-icons/fa';

const HeaderActions = ({ awbNumber, onReset }) => {
  const scrollToShareSection = () => {
    const shareSection = document.getElementById('share-section');
    if (shareSection) {
      shareSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 bg-white rounded-lg shadow-sm p-4">
      <div className="flex items-center gap-3">
        <FaEye className="text-blue-600 text-xl" />
        <div>
          <h1 className="text-xl font-semibold text-gray-800">Tracking Details</h1>
          <p className="text-sm text-gray-600">AWB: {awbNumber}</p>
        </div>
      </div>
      
      {/* Action Buttons */}
      <div className="flex items-center gap-3">
        <button
          onClick={scrollToShareSection}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-200"
        >
          <FaShare className="text-sm" />
          Share
        </button>
        
        <button
          onClick={onReset}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
        >
          Track Another Shipment
        </button>
      </div>
    </div>
  );
};

export default HeaderActions;